import React, { useContext, useEffect,useState } from 'react';
import CarItem from './Item';
import { useCar } from '../../../../hooks/useCar'
import crl from './CarList.module.css'
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import CarSearch from '../Search/CarSearch';
import Pagination from '../../../UI/Pagination/Pagination';
import TotalPrice from '../TotalPrice/TotalPrice'; 
import Refresh from "../../../../assets/Icon/Refresh"; 
import { useTranslation } from 'react-i18next';
import automobyApi from '../../../../Api';
  import DealerDebtModal from '../DealerDebtModal/DealerDebtModal';

const CarList = () => {
  const { t } = useTranslation();
  
  const { carService } = useCar(100);
  const { appState, app } = useContext(AppContext); 

  const [sum, setSum] = useState({ ClientPriceDealer: 0, ClientPriceDealerTransport: 0,  })
    
  useEffect(() => {  

    const listSumDealler = async () => {
      try {
        const response = await automobyApi.post("/car/sum-dealer", carService.filter)
        setSum(response.data)
      } catch (error) {
        console.error("თუ ერორია:" + error);
      }
    }

    listSumDealler();

  }, [carService.filter]);


  const handleRefresh = (event) => {  
    carService.resetDefault()
    app.setupDefault() 
  };


  if (!appState.isLoaded) {
      return null; 
  }

  return <div>


    <div className={crl.headMain}>
      <div className={crl.headflex}> 
        <h1>{t('Cars')}</h1> 
      </div>
      


       <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }} >    
            <DealerDebtModal   dealerId={appState.user.id} amount={0} carService={carService} dealerPage={ true } ></DealerDebtModal> 
       
       <div className={ crl.totalBox }  >   
          <div className={crl.financeBox } >
              <div className={crl.financeDesc }>  {t('Balance')} </div>
              
              <div  style={{color:"#009688", background: '#d3e9e6'}}  className={crl.financeValue}> { sum.ClientPriceDealer + sum.ClientPriceDealerTransport } $</div> 
          </div>  
        </div> 
      </div> 



    </div>
 
 

    <Pagination total={carService.totalCars}
      perPage={carService.filter.limit}
      current={carService.filter.page}
      paginate={(page) => { 
        carService.setFilter({
          ...carService.filter,
          page: page,
        });
      }}
      setLimit={(limit) => {
        carService.setFilter({
          ...carService.filter,
          limit: limit,
        });
      }}
    >
        
        <div style={{ color: "var(--primary-color)", fontWeight: "700", marginRight: "15px", display: "flex", alignItems: "center" }}>
        / {carService.totalPaidCars}</div>
         

        <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
          <span className={crl.switcher} onClick={handleRefresh}>
            <Refresh />  
          </span>
        </div>
         

      </Pagination>
 
      <div className={crl.head}  >
        <CarSearch isTable={null} carService={carService} />
      </div>
    
  
      <div>
        {carService.cars.map((car, index) =>
          <CarItem 
            key={index}
            carItem={car}
            carService={carService}
            statuses={appState.statuses}
            isTable={appState.isTable}
          />)}
      </div> 
 
      {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination total={carService.totalCars}
      perPage={carService.filter.limit}
      current={carService.filter.page}
      paginate={(page) => { 
        carService.setFilter({
          ...carService.filter,
          page: page,
        });
      }}
      setLimit={(limit) => { 
        carService.setFilter({
          ...carService.filter,
          limit: limit,
        });
      }}
    />
  </div>;
}

export default CarList;





 